import type { AccountCreate, AccountOut, LedgerEntryCreate } from "@shop-ledger/shared-types";
import { apiRequest } from "../lib/apiClient";
// `LedgerEntryOut` comes from the local `./types` (not `@shop-ledger/shared-types`) — the
// shared-types version is stale and lacks `created_at`, which the backend added
// 2026-07-13 (§10.5) specifically so the General Ledger date filter / P&L could become
// real. See `api/types.ts`'s file-level doc comment for why this isn't fixed upstream in
// this pass.
import type { LedgerEntryOut } from "./types";

export async function listAccounts(accessToken: string): Promise<AccountOut[]> {
  return apiRequest<AccountOut[]>("/ledger/accounts", { accessToken });
}

export async function createAccount(accessToken: string, body: AccountCreate): Promise<AccountOut> {
  return apiRequest<AccountOut>("/ledger/accounts", { method: "POST", accessToken, body });
}

export async function listLedgerEntries(accessToken: string, branchId?: string): Promise<LedgerEntryOut[]> {
  return apiRequest<LedgerEntryOut[]>("/ledger/entries", { accessToken, query: { branch_id: branchId } });
}

export async function createLedgerEntry(accessToken: string, body: LedgerEntryCreate): Promise<LedgerEntryOut> {
  return apiRequest<LedgerEntryOut>("/ledger/entries", { method: "POST", accessToken, body });
}
